import { removeUrlParams } from '@cascade/core/utils';
import {
  readStorageItem,
  removeStorageItem,
  updateStorageItem,
} from '#utils/index.ts';

const ROOT_PATH = '/';

const REQUESTED_URL_KEY = 'cascade.navigation.requestedUrl';

const PROTOCOL_RELATIVE_PREFIX = '//';

const isSameOriginPath = (value: unknown): value is string =>
  typeof value === 'string' &&
  value.startsWith(ROOT_PATH) &&
  !value.startsWith(PROTOCOL_RELATIVE_PREFIX);

export const getRequestedUrl = (
  href: string,
  transientParams: readonly string[],
): string | undefined => {
  const cleanedHref = removeUrlParams(href, transientParams);

  const { pathname, search, hash } = new URL(cleanedHref);
  const requestedUrl = `${pathname}${search}${hash}`;

  if (requestedUrl === ROOT_PATH || !isSameOriginPath(requestedUrl)) {
    return undefined;
  }

  return requestedUrl;
};

export const saveRequestedUrl = (requestedUrl?: string): void =>
  updateStorageItem(REQUESTED_URL_KEY, requestedUrl);

export const hasRequestedUrl = (): boolean =>
  isSameOriginPath(readStorageItem(REQUESTED_URL_KEY));

export const consumeRequestedUrl = (): string | undefined => {
  const requestedUrl = readStorageItem(REQUESTED_URL_KEY);

  if (requestedUrl === undefined) {
    return undefined;
  }

  removeStorageItem(REQUESTED_URL_KEY);

  return isSameOriginPath(requestedUrl) ? requestedUrl : undefined;
};

export const forgetRequestedUrl = (): void => {
  removeStorageItem(REQUESTED_URL_KEY);
};
